export var BitConditonLogic;
(function (BitConditonLogic) {
    BitConditonLogic[BitConditonLogic["Off"] = 0] = "Off";
    BitConditonLogic[BitConditonLogic["On"] = 1] = "On";
})(BitConditonLogic || (BitConditonLogic = {}));
